import React from 'react';
import ReactDOM from 'react-dom/client';
import "tailwindcss/tailwind.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ContractProvider } from './contexts/ContractContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContractProvider>
    <App />
    </ContractProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
